import { render } from "./thankYouComponent.vue?vue&type=template&id=3331ac3c"
import script from "./thankYouComponent.vue?vue&type=script&lang=js"
export * from "./thankYouComponent.vue?vue&type=script&lang=js"

import "./thankYouComponent.vue?vue&type=style&index=0&id=3331ac3c&lang=css"

import exportComponent from "../../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"cartridges/int_guidedProductFinder/cartridge/client/default/js/components/thankYouComponent.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "3331ac3c"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('3331ac3c', __exports__)) {
    api.reload('3331ac3c', __exports__)
  }
  
  module.hot.accept("./thankYouComponent.vue?vue&type=template&id=3331ac3c", () => {
    api.rerender('3331ac3c', render)
  })

}


export default __exports__